import { combine } from 'effector'

import { getAvailableFeaturesFx } from './feature-flags'

export const $importantLoadingsCount = combine(
  getAvailableFeaturesFx.pending,
  (...loadings) => {
    return loadings.filter(Boolean).length
  },
)
